import { useContext } from "react";
import { ColorModeContext, ColorModeType } from "..";

export const useColorMode = (): ColorModeType => {
    const { color: mode, toggleColorMode, product, changeProduct } = useContext(ColorModeContext);

    return { color: mode, toggleColorMode, changeProduct, product };
};
